import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TrendingDown, ArrowRight, Award } from 'lucide-react';
import { CatalogAPI, formatPrice } from '../lib/api';

const BiggestSavings = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    CatalogAPI.products({ limit: 80 }).then((data) => {
      const scored = products
        .map((p) => {
          const prices = (p.variants || []).map((v) => v.price).filter(Boolean);
          if (prices.length < 2) return null;
          const min = Math.min(...prices);
          const max = Math.max(...prices);
          const diff = max - min;
          const pct = max > 0 ? Math.round((diff / max) * 100) : 0;
          return { product: p, min, max, diff, pct, offersCount: prices.length };
        })
        .filter(Boolean)
        .sort((a, b) => b.pct - a.pct)
        .slice(0, 6);
      setItems(scored);
    }).catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="bg-white py-12 lg:py-16 border-t border-[#E8E0D0]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-end justify-between gap-4 mb-8 flex-wrap">
          <div>
            <div className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-[#C75B27] font-semibold mb-2">
              <TrendingDown className="w-4 h-4" /> Économisez en comparant
            </div>
            <h2 className="font-serif text-3xl lg:text-4xl font-semibold text-[#1F4D3F]">Les plus gros écarts de prix</h2>
            <p className="text-[#7A6F5C] mt-2 max-w-2xl">
              Le même produit dentaire peut coûter jusqu'à 60% moins cher d'un fournisseur à l'autre.
              Comparez systématiquement avant de commander.
            </p>
          </div>
          <Link to="/categories" className="hidden md:inline-flex items-center gap-1 text-[#1F4D3F] hover:text-[#173B30] font-medium">
            Voir tout le catalogue <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map(({ product, min, max, diff, pct, offersCount }) => (
            <Link
              key={product.id}
              to={`/produit/${product.id}`}
              className="group bg-white border border-[#E8E0D0] rounded-2xl overflow-hidden hover:border-[#1F4D3F] hover:shadow-lg transition flex flex-col"
            >
              <div className="relative aspect-[16/10] bg-[#FAF7F2] overflow-hidden">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                <div className="absolute top-3 left-3 bg-[#C75B27] text-white text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1">
                  <TrendingDown className="w-3.5 h-3.5" /> jusqu'à −{pct}%
                </div>
                <div className="absolute top-3 right-3 bg-white/95 backdrop-blur text-[#1F4D3F] text-xs font-medium px-2 py-1 rounded border border-[#E8E0D0]">
                  {offersCount} offres
                </div>
              </div>

              <div className="p-4 flex flex-col flex-1">
                <div className="text-xs text-[#7A6F5C] uppercase tracking-wider">{product.brand}</div>
                <div className="mt-1 text-sm font-medium text-[#2D2A26] line-clamp-2 min-h-[40px]">{product.name}</div>

                <div className="mt-3 p-3 bg-[#FAF7F2] rounded-lg">
                  <div className="flex items-baseline justify-between">
                    <div>
                      <div className="text-[10px] text-[#7A6F5C] uppercase tracking-wider flex items-center gap-1">
                        <Award className="w-3 h-3 text-emerald-600" /> Meilleur prix
                      </div>
                      <div className="font-serif text-xl font-semibold text-[#1F4D3F]">{formatPrice(min)}</div>
                    </div>
                    <div className="text-right">
                      <div className="text-[10px] text-[#7A6F5C] uppercase tracking-wider">Le plus cher</div>
                      <div className="text-sm text-[#7A6F5C] line-through">{formatPrice(max)}</div>
                    </div>
                  </div>
                  <div className="mt-2 pt-2 border-t border-[#E8E0D0] flex items-center justify-between text-xs">
                    <span className="text-[#5A5247]">Économie potentielle</span>
                    <span className="font-semibold text-[#C75B27]">{formatPrice(diff)}</span>
                  </div>
                </div>

                <div className="mt-3 text-xs font-medium text-[#1F4D3F] inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                  Comparer les {offersCount} offres <ArrowRight className="w-3.5 h-3.5" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BiggestSavings;
